// const LOCATION_MARKER = `https://o.i-firefly.com/app/location.40x68.png`;

import { Fits } from "@crt/math";
// const LOCATION_MARKER = `https://o.i-firefly.com/app/location-40.png`;

export function buildStaticMapUrl(location, size) {
  var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var width = Math.max(Math.round(size.width), 50);
  var height = Math.max(Math.round(size.height), 50);
  if (width > 1680 || height > 1200) {
    var fit = Fits.contain({
      width: width,
      height: height
    }, {
      width: 1680,
      height: 1200
    });
    width = fit.frame.width;
    height = fit.frame.height;
  }
  var sizeValue = "".concat(width, "*").concat(height);
  var center = "".concat(location.lat, ",").concat(location.lng);
  var zoomValue = Math.min(Math.max(Math.round(zoom), 4), 18);
  return "https://a.i-firefly.com/staticmap/".concat(center, "/").concat(sizeValue, "/zoom=").concat(zoomValue, "&scale=2&centerMarker=true");
}